import {
  AssetType,
  CertificateType,
  CurrencyCode,
  Offer,
  OfferGroupStatus,
  OfferStatus,
  OrderPosition,
  OrderStatus,
  OrderType,
  RegistryCode,
} from "@/app/types/generated/graphql";

export const demoAskOrder = {
  id: "dd9b0dc3-ef67b906bf68",
  tenantId: "08cd2505-2195463332e8",
  account: {
    id: "25ec0a20-a312f22e3467",
  },
  assetType: AssetType.Rec,
  position: OrderPosition.Ask,
  status: OrderStatus.Open,
  registryCode: RegistryCode.Mrets,
  initialVolume: 19,
  currentVolume: 19,
  completedOn: null,
  createdOn: "2024-08-30T03:58:26.545Z",
  orderNumber: "20240830-EVAF",
  allowCounterOffers: true,
  type: OrderType.Limit,
  price: {
    currencyCode: CurrencyCode.Usd,
    amount: "300",
  },
  updatedOn: "2024-08-30T03:58:27.167Z",
  attributes: {
    vintages: ["2021-BACK_HALF"],
    locations: ["BC"],
    fuelSources: ["WND"],
    eligibilities: ["il_utility"],
    projects: ["hxa5xf1v8wvx5tcvez113jwxeto24q7h"],
    certifications: [],
    commencementDate: "2003-09-16",
  },
  vintage: "",
  vintages: ["2021 - BH"],
  eligibilities: ["Illinois Utility"],
  location: "-",
  locations: ["British Columbia"],
  fuelSources: ["Wind"],
  project: "-",
  projects: ["secret evidence"],
  certifications: [],
  certificationsAndEligibilities: [
    {
      label: "certifications",
      value: [],
    },
    {
      label: "eligibilities",
      value: ["Illinois Utility"],
    },
  ],
};

export const demoAskOrderERCOT = {
  id: "dd9b0dc3-ef67b906bf68",
  tenantId: "08cd2505-2195463332e8",
  account: {
    id: "25ec0a20-a312f22e3467",
  },
  assetType: AssetType.Rec,
  position: OrderPosition.Ask,
  status: OrderStatus.Open,
  registryCode: RegistryCode.Ercot,
  initialVolume: 19,
  currentVolume: 19,
  completedOn: null,
  createdOn: "2024-08-30T03:58:26.545Z",
  orderNumber: "20240830-EVAF",
  allowCounterOffers: true,
  type: OrderType.Limit,
  price: {
    currencyCode: CurrencyCode.Usd,
    amount: "300",
  },
  updatedOn: "2024-08-30T03:58:27.167Z",
  attributes: {
    vintages: ["2021-Q1"],
    fuelSources: ["BM"],
    eligibilities: [],
    projects: ["Project Hydra"],
    certifications: ["CRS"],
    certificateTypes: [CertificateType.Cp],
  },
  vintage: "",
  vintages: ["2021 - Q1"],
  eligibilities: [],
  location: "-",
  locations: [],
  fuelSources: ["Biomass"],
  project: "-",
  projects: ["Project Hydra"],
  certifications: ["CRS Listed"],
  certificateTypes: ["Compliance Premium"],
  certificationsAndEligibilities: [
    {
      label: "certifications",
      value: ["CRS Listed"],
    },
    {
      label: "eligibilities",
      value: [],
    },
  ],
};

export const counteredOrdersData = [
  {
    id: "294d6972-cfa6-45b8-86d3-44dea77fda9a",
    tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
    account: {
      id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      __typename: "Account",
    },
    assetType: "REC",
    registryCode: "ERCOT",
    position: "ASK",
    status: "COMPLETE",
    initialVolume: 2830,
    currentVolume: 0,
    completedOn: "2025-10-27T08:03:16.702Z",
    createdOn: "2025-10-14T19:24:24.066Z",
    orderNumber: "ON-1UAI2Z5ISG",
    allowCounterOffers: true,
    type: "LIMIT",
    price: {
      currencyCode: "USD",
      amount: "205",
      __typename: "Money",
    },
    updatedOn: "2025-10-27T08:03:16.731Z",
    attributes: {
      vintages: ["2024-Q3"],
      locations: [],
      projects: ["-"],
      fuelSources: ["SO"],
      eligibilities: [],
      certifications: ["CRS"],
      commencementDate: null,
      certificateTypes: ["R"],
      __typename: "RecAttributes",
    },
    __typename: "Order",
  },
  {
    id: "e18a2706-7bfe-4e28-a81f-d7c0ef46fbd8",
    tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
    account: {
      id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
      __typename: "Account",
    },
    assetType: "REC",
    registryCode: "ERCOT",
    position: "ASK",
    status: "COMPLETE",
    initialVolume: 47170,
    currentVolume: 0,
    completedOn: "2025-10-27T08:03:35.755Z",
    createdOn: "2025-10-14T19:24:24.066Z",
    orderNumber: "ON-1UAI2Z5ISH",
    allowCounterOffers: true,
    type: "LIMIT",
    price: {
      currencyCode: "USD",
      amount: "205",
      __typename: "Money",
    },
    updatedOn: "2025-10-27T08:03:35.759Z",
    attributes: {
      vintages: ["2024-Q3"],
      locations: [],
      projects: ["-"],
      fuelSources: ["SO"],
      eligibilities: [],
      certifications: ["CRS"],
      commencementDate: null,
      certificateTypes: ["R"],
      __typename: "RecAttributes",
    },
    __typename: "Order",
  },
];

export const ercotCounteredOrdersData = [
  {
    id: "c64a90f80-4d7f1b56372c",
    tenantId: "08cd2505-18d4-488b-a960-2195463332e8",
    accountId: "d098227a-44-672ea907255a",
    registryCode: RegistryCode.Ercot,
    assetType: AssetType.Rec,
    position: OrderPosition.Ask,
    status: OrderStatus.Open,
    initialVolume: 5,
    currentVolume: 5,
    completedOn: null,
    createdOn: "2024-09-03T09:49:03.901Z",
    orderNumber: "20240903-KYC3",
    allowCounterOffers: true,
    type: OrderType.Limit,
    price: {
      currencyCode: CurrencyCode.Usd,
      amount: "1100",
    },
    updatedOn: "2024-09-03T09:49:04.415Z",
    attributes: {
      vintages: ["2021-Q1"],
      fuelSources: ["BM"],
      eligibilities: [],
      projects: ["Project Hydra"],
      certifications: ["CRS"],
      certificateTypes: [CertificateType.Cp],
    },
    vintage: "",
    vintages: ["2021 - Q1"],
    eligibilities: [],
    location: "-",
    locations: ["British Columbia"],
    fuelSources: ["Biomass"],
    project: "-",
    projects: ["Project Hydra"],
    certifications: ["CRS Listed"],
    certificateTypes: ["Compliance Premium"],
    certificationsAndEligibilities: [
      {
        label: "certifications",
        value: ["CRS Listed"],
      },
      {
        label: "eligibilities",
        value: [],
      },
    ],
  },
  {
    id: "dd9b0dc3-af67b906bf68",
    tenantId: "08cd2505-18d4-488b-a960-2195463332e8",
    accountId: "25ec0a20-7147-22e3467",
    registryCode: RegistryCode.Ercot,
    assetType: AssetType.Rec,
    position: OrderPosition.Ask,
    status: OrderStatus.Open,
    initialVolume: 19,
    currentVolume: 19,
    completedOn: null,
    createdOn: "2024-08-30T03:58:26.545Z",
    orderNumber: "20240830-EVAF",
    allowCounterOffers: true,
    type: OrderType.Aon,
    price: {
      currencyCode: CurrencyCode.Usd,
      amount: "300",
    },
    updatedOn: "2024-08-30T03:58:27.167Z",
    attributes: {
      vintages: ["2021-Q1"],
      fuelSources: ["GT"],
      eligibilities: [],
      projects: ["Project Hydra"],
      certifications: ["CRS"],
      certificateTypes: [CertificateType.R],
    },
    vintage: "",
    vintages: ["2021 - Q1"],
    eligibilities: [],
    location: "-",
    locations: ["British Columbia"],
    fuelSources: ["GeoThermal"],
    project: "-",
    projects: ["Project Hydra"],
    certifications: ["CRS Listed"],
    certificateTypes: ["Regular"],
    certificationsAndEligibilities: [
      {
        label: "certifications",
        value: ["CRS Listed"],
      },
      {
        label: "eligibilities",
        value: [],
      },
    ],
  },
];

export const offerGroupsData = [
  {
    id: "offer-group-1",
    tenantId: "08cd2505-18d4-48463332e8",
    offerGroupNumber: "OFG1J2ONAVZOG",
    expandedData: {
      offerGroupId: "offer-group-1",
    },
    accountId: "25ec0a20-7147-42f22e3467",
    sourceOrderNumber: "20240903-KYC3",
    issuedOrderNumber: "20240903-KYC3",
    status: OfferGroupStatus.InProgress,
    createdOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-group-2",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "1FG1J2ONAVZOG",
    expandedData: { offerGroupId: "offer-group-2" },
    accountId: "27ec0a20-7147-42f22e3467",
    sourceOrderNumber: "20240903-KYC8",
    issuedOrderNumber: "20240903-KYC8",
    status: OfferGroupStatus.Accepted,
    createdOn: "2024-10-24T02:15:47.274Z",
  },
  {
    id: "offer-group-3",
    tenantId: "08cd257-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    expandedData: { offerGroupId: "offer-group-3" },
    accountId: "26ec0a20-7147-42f22e3467",
    sourceOrderNumber: "20240903-KYC4",
    issuedOrderNumber: "20240903-KYC4",
    status: OfferGroupStatus.ExecutionFailed,
    createdOn: "2024-10-21T04:11:47.274Z",
  },
  {
    id: "offer-group-4",
    tenantId: "08cd257-13d4-48463332e8",
    offerGroupNumber: "2FG1KONAVZOG",
    expandedData: { offerGroupId: "offer-group-4" },
    accountId: "29ec0a20-7147-42f22e3467",
    sourceOrderNumber: "20240903-KYC6",
    issuedOrderNumber: "20240903-KYC46",
    status: OfferGroupStatus.Withdrawn,
    createdOn: "2024-10-21T04:11:47.274Z",
  },
];

export const demoCounterOffersData: Offer[] = [
  {
    id: "offer-1",
    tenantId: "08cd257-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "OF1JJN3SIESG",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Requested,
    statusMessage: "Offer is in requested state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-2",
    tenantId: "08cd257-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "f984e5a2-f3ac-4469-af5bfa8",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Requested,
    statusMessage: "Offer is in requested state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-3",
    tenantId: "08cd2505-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Pending,
    statusMessage: "Offer is in pending state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-4",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Countered,
    statusMessage: "Offer is in countered state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-5",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Accepted,
    statusMessage: "Offer is in accepted state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-6",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Executed,
    statusMessage: "Offer is in executed state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-7",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.ExecutionFailed,
    statusMessage: "Offer is in execution failed state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-8",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Rejected,
    statusMessage: "Offer is in rejected state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-9",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Withdrawn,
    statusMessage: "Offer is in withdrawn state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
  {
    id: "offer-10",
    tenantId: "08cd2506-18d4-48463332e8",
    offerGroupNumber: "2FG1J2ONAVZOG",
    toAccountId: "25ec0a20-7147-42f22e3467",
    fromAccountId: "27ec0a20-7147-42f22e3467",
    offerNumber: "20240903-KYC3",
    unitPrice: "300",
    volume: "300",
    status: OfferStatus.Failed,
    statusMessage: "Offer is in failed state",
    createdOn: "2024-10-22T03:11:47.274Z",
    counteredOn: "2024-10-22T03:11:47.274Z",
    requestedOn: "2024-10-22T03:11:47.274Z",
  },
];

export const demoReviewOfferResponse = {
  processing: true,
  message: "Processing action 'WITHDRAW' for offer OF1JJN3SIESG",
};

export const counteredOrdersQuery = {
  read(_: any) {
    return {
      orders: counteredOrdersData,
      offsetInfo: {
        offset: 0,
        limit: 20,
        total: 1,
      },
    };
  },
};

const demoOfferGroups = [
  {
    id: "6b45e706-f077-4a00-aa34-b2b0e4d62465",
    tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
    offerGroupNumber: "OFG1UCOQISNSW",
    accountId: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
    sourceOrderNumber: "ON-1UAI2Z5ISG",
    issuedOrderNumber: null,
    status: "FAILED",
    createdOn: "2025-10-16T17:51:03.992Z",
    __typename: "OfferGroup",
  },
  {
    id: "62dbf476-6458-46aa-a642-44be4e01b644",
    tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
    offerGroupNumber: "OFG1UBOM01MQO",
    accountId: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
    sourceOrderNumber: "ON-1UAI2Z5ISG",
    issuedOrderNumber: null,
    status: "FAILED",
    createdOn: "2025-10-15T20:31:09.537Z",
    __typename: "OfferGroup",
  },
];

export const offerGroupsQuery = {
  read(_: any) {
    return demoOfferGroups;
  },
};

const offers = [
  {
    id: "1d8f55bd-4522-45d7-ac37-5aa1e82f5b79",
    tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
    offerGroupNumber: "OFG1UCOQISNSW",
    offerNumber: "OF1UCOQISRR4",
    fromAccountId: "cd23c4b8-3c0c-45fd-ad25-eb3988485850",
    toAccountId: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
    unitPrice: 200,
    volume: 2830,
    status: "FAILED",
    statusMessage: "Order 'ON-1U3VVSL9Q8' has been withdrawn from the market.",
    counteredOn: null,
    requestedOn: "2025-10-16T17:51:04.130Z",
    createdOn: "2025-10-16T17:51:03.997Z",
    __typename: "Offer",
  },
];
export const offersQuery = {
  read(_: any) {
    return offers;
  },
};
